module.exports = __webpack_public_path__ + "static/media/4.44d911dd.png";